import { View } from 'react-native'

import { Stack } from '@/src/elements/navigation/Stack'

const CommunitySubscriptionJoinNextLayout = () => {
  return (
    <View className="w-full flex-1">
      <Stack screenOptions={{ headerShown: false }} />
    </View>
  )
}
export default CommunitySubscriptionJoinNextLayout
